import React, { Fragment } from 'react'
import styled from 'react-emotion'
import { colors } from "../../styles"

const Tooltip = styled('div')`
  position: relative;
  display: inline-block;
  :hover {
    span {
      visibility: visible;
    }
  }
`
const TooltipText = styled('span')`
  visibility: hidden;
  width: 400px;
  background-color: ${colors.tui_blue_25};
  color: ${colors.tui_dark_blue};
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, .1);
  font-size: 16px;
  text-align: center;
  padding: 5px;
  border-radius: 6px;
  position: absolute;
  z-index: 1;
  top: -14px;
  left: 110%;

  ::after {
    content: " ";
    position: absolute;
    top: 50%;
    right: 100%;
    margin-top: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent ${colors.tui_blue_25} transparent transparent;
  }
`

export default ({ children, text }) => {
    return (
        <Fragment>
            <Tooltip>
                {children}
                <TooltipText>
                   {text} 
                </TooltipText>
            </Tooltip>
        </Fragment>
    )
}